import React from 'react';
import {
  Grid,
  TextField,
} from "@material-ui/core";
import {
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { Controller } from 'react-hook-form';

function AssignmentForm(props){
  const { isEditableForm } = props;
  const { name, end_date, description } = props.data || {};  
  const { register, errors, control } = props.formConfig; 
  
  return (
    <form noValidate autoComplete="off" >      
        <Grid container spacing={3} direction="row">
          <Grid item xs={6}>
            <TextField 
              id="filled-basic"
              label="Name"
              name="name"
              placeholder="Assignment name"
              variant="filled"
              disabled={!isEditableForm}
              fullWidth={true}

              defaultValue={name}
              inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
              error={errors.name ? true : false}
              helperText={errors.name ? errors.name.message : null}
            />
          </Grid>

          <Grid  item xs={6}>
            <Controller 
              as={KeyboardDateTimePicker}
              disabled={!isEditableForm}
              autoOk
              format="MM/DD/YYYY hh:mm A"
              views={["year", "month", "date", "hours" , "minutes"]}
              label="Due Date"
              placeholder="mm/dd/yyyy"
              variant="inline"    
              inputVariant="filled"
              fullWidth={true} 
              error={errors.end_date ? true : false}
              helperText={errors.end_date ? errors.end_date.message : null}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              // rules={{ required: "Field Required", pattern: /^[A-Za-z]+$/i  }}
              name="end_date"               
              control={control} 
              defaultValue={end_date || null} />
          </Grid>

          <Grid item xs={12}>
            <TextField 
              name="description"                  
              id="description"
              label="Description"                  
              multiline
              variant="filled"
              fullWidth={true}
              disabled={!isEditableForm}
              rows={2}
              rowsMax={5}
  
              defaultValue={description}
              inputRef={register({ minLength: { value: 5, message: "Too short!." } })}
              error={errors.description ? true : false}
              helperText={errors.description ? errors.description.message : null}
            />
          </Grid>
        
          {/* Show Form action buttons only when Edit action is active */}
          {props.children}
        </Grid>
    </form>
  )
}

export default AssignmentForm;